import { render, staticRenderFns } from "./ScientistsList.vue?vue&type=template&id=145fe5fc&scoped=true&"
import script from "./ScientistsList.vue?vue&type=script&lang=js&"
export * from "./ScientistsList.vue?vue&type=script&lang=js&"
import style0 from "./ScientistsList.vue?vue&type=style&index=0&id=145fe5fc&scoped=true&lang=scss&"
import style1 from "./ScientistsList.vue?vue&type=style&index=1&id=145fe5fc&lang=scss&scoped=true&"
import style2 from "./ScientistsList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145fe5fc",
  null
  
)

export default component.exports